import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Immediately redirect to the specified URL when the component mounts
    window.location.href = 'https://1millionpixelgrid.com/';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 text-center">
      <div className="animate-pulse flex flex-col items-center">
        <svg 
          className="w-12 h-12 text-blue-500 mb-4 animate-spin" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
          ></circle>
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">Redirecting...</h1>
        <p className="text-gray-500">
          If you are not redirected automatically,{' '}
          <a 
            href="https://1millionpixelgrid.com/" 
            className="text-blue-600 hover:underline"
          >
            click here
          </a>.
        </p>
      </div>
    </div>
  );
}

export default App;